import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LandingPageAppResource from './LandingPageAppResource';
import LuLandingPageSectionTypeAppResource from './LuLandingPageSectionTypeAppResource';
import MarketAppResource from './MarketAppResource';

class LandingPageFinanceSectionAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'landing-page-finance-section';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'landings/pages/finances/sections';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'landingPageUuid',
      'landingPageSectionTypeId',
      'hasInfo',
      'hasMultipleLenders',
      'singleLenderName',
      'singleLenderUrl',
      'state',
      'marketUuid',
      'landingPage',
      'type',
      'market',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      landingPage:             LandingPageAppResource,
      type:             LuLandingPageSectionTypeAppResource,
      market:             MarketAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      landingPage: 'landing_page_uuid',
      type: 'landing_page_section_type_id',
      market: 'market_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      landingPageUuid: {
        type: 'string',
      },
      landingPageSectionTypeId: {
        type: 'integer',
        presence:                 true,
      },
      hasInfo: {
        type: 'boolean',
      },
      hasMultipleLenders: {
        type: 'boolean',
      },
      singleLenderName: {
        type: 'string',
        length: {
          maximum: 255,
        },
      },
      singleLenderUrl: {
        type: 'string',
        length: {
          maximum: 255,
        },
      },
      state: {
        type: 'string',
        length: {
          maximum: 2,
        },
      },
      marketUuid: {
        type: 'string',
      },
    };
  }

}

export default LandingPageFinanceSectionAppResource;
